import FetchClient, { type ApiResponse } from "./FetchClient";

export type StoreRunnerJobStatus =
  | "queued"
  | "running"
  | "succeeded"
  | "failed"
  | "timed_out"
  | "cancelled";

export interface StoreRunnerTarget {
  retailer: "walmart";
  userId: string;
  userName?: string;
  storeId: string;
  storeName?: string;
  storeAddress?: string;
  postalCode?: string;
  categoryCount: number;
}

export interface StoreRunnerJob {
  id: string;
  retailer: "walmart";
  userId: string;
  userName?: string;
  storeId: string;
  storeName?: string;
  status: StoreRunnerJobStatus;
  progress: number;
  categoriesTotal: number;
  categoriesCompleted: number;
  currentCategory?: string;
  message?: string;
  error?: string;
  createdAt: string;
  startedAt?: string;
  finishedAt?: string;
  automaticTeardownAt?: string;
}

export interface StoreRunnerTargetsResponse {
  targets: StoreRunnerTarget[];
  total: number;
  retailers: string[];
}

export interface StoreRunnerJobsResponse {
  jobs: StoreRunnerJob[];
  total: number;
  maxRuntimeSeconds: number;
}

export async function getStoreRunnerTargets(
  retailer = "walmart"
): Promise<StoreRunnerTargetsResponse> {
  const query = new URLSearchParams({ retailer });
  const response = await FetchClient.get<ApiResponse<StoreRunnerTargetsResponse>>(
    `/admin/store-runner/targets?${query.toString()}`
  );
  return response.data;
}

export async function getStoreRunnerJobs(
  retailer = "walmart"
): Promise<StoreRunnerJobsResponse> {
  const query = new URLSearchParams({ retailer });
  const response = await FetchClient.get<ApiResponse<StoreRunnerJobsResponse>>(
    `/admin/store-runner/jobs?${query.toString()}`
  );
  return response.data;
}

export async function createStoreRunnerJob(
  target: Pick<StoreRunnerTarget, "retailer" | "userId" | "storeId">
): Promise<StoreRunnerJob> {
  const response = await FetchClient.post<ApiResponse<StoreRunnerJob>>(
    "/admin/store-runner/jobs",
    target
  );
  return response.data;
}
